type RaygunStackItem = {
  LineNumber: number;
  ColumnNumber: number;
  ClassName: string;
  FileName: string;
  MethodName: string;
};

type RaygunPayload = {
  OccurredOn: Date;
  Details: {
    Error: {
      ClassName: string;
      Message: string;
      StackTrace: RaygunStackItem[];
    };
    Tags: string[];
    UserCustomData: any;
  };
};

export function setupRaygunErrorLogging() {
  window.rg4js?.('groupingKey', (payload: RaygunPayload) => {
    return payload.Details.Error.Message;
  });
}
